// #224 — AJAX akce bez zpětné vazby. Diagnóza (sonda 2026-08-31, dvě kola):
//
//   • Server chybu VRACÍ — `{"code":500,"messages":{"errors":[…]}}` u neplatného
//     kupónu i u stropu množství („Dostupných je pouze N položek. Množství
//     nebylo změněno.") — ale default JS ji zahodí: žádný showMessage(), žádná
//     DOM mutace. Nativní `div.messages` navíc stojí až ZA obsahem stránky
//     (y ≈ 6000), takže i ručně volaný showMessage() skončí mimo viewport.
//   • watchdogSetup 200 zavře modal beze slova. (Klientská validace „vyberte
//     jednu z možností" jde nativně do `.watchdog-messages` V modalu — tu
//     neduplikujeme, běží bez POSTu.)
//   • jQuery(document).ajaxComplete na tyhle cally NEfiruje — Shoptet jede
//     vlastní XHR wrapper → jediný spolehlivý hook je patch XMLHttpRequest.
//
// Úspěchy addCartItem/setCartItemAmount se nehlásí — mají vlastní feedback
// (modal „Přidáno do košíku" / cartToast, překreslený košík). Hlásí se jejich
// CHYBY (vyprodáno, skladový strop) a úspěch kupónu + hlídání.

import { showFeedback } from './feedbackToast.js';
import L from '../locale/cs/ajaxFeedback.js';

const RULES = [
  { re: /\/action\/Cart\/addDiscountCoupon\//, success: L.coupon },
  { re: /\/action\/ProductDetail\/watchdogSetup\//, success: L.watchdog },
  { re: /\/action\/Cart\/addCartItem\//, success: null },
  { re: /\/action\/Cart\/setCartItemAmount\//, success: null },
];

function ruleFor(url) {
  for (const rule of RULES) {
    if (rule.re.test(url || '')) return rule;
  }
  return null;
}

// Text hlášky bez HTML — server posílá `<br/>` uprostřed vět. Bez DOM
// (regex stačí na tagy, entity server neposílá) — funkce běží i v Node testech.
function plain(value) {
  return String(value == null ? '' : value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Odpověď endpointu → hláška pro toast (nebo null = mlčet).
 * Exportované kvůli unit testům v devchecku.
 */
export function feedbackFor(url, body) {
  const rule = ruleFor(url);
  if (!rule) return null;
  let data;
  try {
    data = JSON.parse(body);
  } catch (e) {
    return null;
  }
  if (!data || typeof data.code !== 'number') return null;
  if (data.code >= 400) {
    const errors = data.messages && Array.isArray(data.messages.errors) ? data.messages.errors : [];
    const text = plain(errors.length ? errors.join(' ') : data.message);
    return text ? { kind: 'error', text: text } : null;
  }
  return rule.success ? { kind: 'success', text: rule.success } : null;
}

export function initAjaxFeedback() {
  const proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (!proto || proto.__bsFeedback) return;
  proto.__bsFeedback = true;

  const origOpen = proto.open;
  proto.open = function (method, url) {
    this.__bsFbUrl = String(url || '');
    return origOpen.apply(this, arguments);
  };

  const origSend = proto.send;
  proto.send = function () {
    const xhr = this;
    if (ruleFor(xhr.__bsFbUrl)) {
      xhr.addEventListener('load', function () {
        let body = '';
        try {
          body =
            xhr.responseType === '' || xhr.responseType === 'text'
              ? xhr.responseText
              : JSON.stringify(xhr.response);
        } catch (e) {
          /* responseText umí házet u cizích responseType */
        }
        const out = feedbackFor(xhr.__bsFbUrl, body);
        if (out) showFeedback(out.text, out.kind);
      });
    }
    return origSend.apply(this, arguments);
  };
}
